export function formatDocumentName(documentName) {
    if (!documentName || typeof documentName !== "string") {
        throw new Error("Invalid document name");
    }

    return documentName
        .trim() 
        .replace(/[^a-zA-Z0-9\s-]/g, "") 
        .replace(/\s+/g, "_") 
        .substring(0, 100); 
}